const prefix = '/admin';

export const SPECIFIC_LIST_TAG = `${prefix}/risk-sectors`;
export const SPECIFIC_DETAILS_TAG = `${prefix}/risk-sectors/id`;
